import type { ReactNode } from 'react'

import { HcCollapse } from '@hotmart-org-ca/cosmos-web/dist/react/hc-collapse'

import CollapseItem from './collapseItem'

export type CollapseProps = {
  label?: string
  collapseActions?: ReactNode
  children: ReactNode
  className?: string
}

const Collapse = ({ collapseActions, children, className, label = '' }: CollapseProps) => {
  return (
    <HcCollapse slot='items' class={className}>
      {collapseActions ? collapseActions : label}
      {children}
    </HcCollapse>
  )
}

const CompoundCollapse = Object.assign(Collapse, { CollapseItem })

export default CompoundCollapse
